
type EncodedResult = {
	parsed: boolean
	slug: string
	date?: string
}

export const useEncoded = (pathname: string): EncodedResult => {
	const match = pathname.match(/^\/scan-me\/(?<slug>[^/]+)(\/(?<date>\d{4}-\d{2}-\d{2}))?\/?$/);
	if (!match || !match.groups) {
		return {
			parsed: false,
			slug: '',
		};
	}

	const {slug, date} = match.groups;
	return {
		parsed: true,
		slug,
		date,
	};
};
